import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { Coordinates } from './LoadSiteData'
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';
import CHF from "assets/CHF.png";
import CHF1P from "assets/CHF1P.png";
import CHF2P from "assets/CHF2P.png";
import ZL from "assets/ZoneLog_Logger.png"
import { GutermannModelConverter } from "../../Utils/GutermannModelCoverter";
import yellowMarker from '../../assets/mapLocationMarkers/pinYellow.png';
import redMarker from '../../assets/mapLocationMarkers/pinRed.png';
import moment from 'moment'


export interface Site {
    id: number;
    siteNameUserFriendly: string;
    siteName: string;
    created: Date;
    deleted: Date | null;
    latitude: number | null;
    longitude: number | null;
    groups: Array<{ id: number; displayName: string }>;
    defaultSite: boolean;
    fkCompanyId: number;
    fkEASiteId: number | null;
    EASite: string;
    lastUpdate: Date | null;
    alarmState: number | null;
    alarmsEnabled: number | null;
    loggers: Array<SiteLogger>;
    lastReading?: Date | null;
    hasActiveLoggers?: string;
    boundary?: string;





}

export interface SiteLogger {
    alarmMessage0: string;
    alarmMessage1: string;
    alarmMessage2: string;
    alarmMessage3: string;
    alarmMessage4: string;
    alarmMessage5: string;
    alarmMessage6: string;
    alarmMessage7: string;
    alarmMessage8: string;
    alarmMessage9: string;
    alarmMessage10: string;
    alarmMessage11: string;
    alarmMessage12: string;
    alarmMessage13: string;
    alarmMessage14: string;
    alarmMessage15: string;
    alarmState: number;
    alarmsEnabled: number;
    channelARef: string;
    channelBRef: string;
    channelCRef: string;
    channelDRef: string;
    channelERef: string;
    channels: string;
    channelsAvail: number | null;
    deploymentDate: string | null;
    deviceName: string | null;
    dormant: boolean;
    fkSiteId: number | null;
    latitude: number | null;
    loggerId: number;
    longitude: number | null;
    meterConfig: number | null;
    model: string;
    modelId: string;
    serial: number;
    siteName: string;
    siteNameUserFriendly: string;
    isSiteOutput?: boolean
    companyName?: string
    hasGps: boolean | null
}
 



export interface RedirectProps {
    siteName: string;
    siteId: number | null;
    serial: string;
    deviceId: number | null;
}


export interface GPS {
    position: { lat: number, lng: number }
    icon: string
    serial: number | null
    id: number
    tooltip: Tooltip


}

interface Tooltip {
    model: string
    img: string
    deviceName: string | null
}

export interface BoundaryData {
    path: Array<Coordinates>
    styling: BoundaryStyling
}

export interface BoundaryStyling {
    strokeWeight: number
    strokeColor: string
    areaColor: string
    transparency: number
}

export const defaultCenter = window.location.hostname.includes("zonelog.net")
    ? { lat: 47.17442830752493, lng: 8.517189402835617 }
    : { lat: 50.744094943532446, lng: -3.99597602646894 };


export interface Company {
    name: string
    id: number
    isParent: boolean
}



export const reloadData = (


    setLoading: (loading:boolean) => void,
    siteId: number,
    setPolygonPath: (path: Coordinates[]) => void ,
    setSite: (site: Site) => void,
    setLoggerData: (loggerData: SiteLogger[]) => void,
    setBoundaryStyle: (styling: BoundaryStyling) => void,
    setHasBoundary: (hasBoundary: boolean) => void,
    setMarkers: (markersData: GPS[]) => void,
    setLoggersToBeAssigned: () => void,
    setAuthorized: (auth: boolean) => void,
    startDate: Date,
    setLastDataDate: (date: Date) => void,
    setHistoricLoggerData: (historicData: SiteLogger) => void,
    setLoggerIds: (loggerIdData: number[]) => void



): void => {
    setLoading(true)
    const loggerIdsTemp: number[] | null = []
    const preparedLoggers = []
    CallGetAPI(CreateUrl('/api/aquaguard/site?id=' + siteId), {})
        .then((data: Site) => {
            console.log(data)
            setPolygonPath([])
            const markersTemp: GPS[] | null = []
            data.loggers.sort((a, b) => a.serial - b.serial)
            setLoggerData(data.loggers)
            if (data.loggers.length > 0) {
                data.loggers.forEach((logger: APILoggerDetail) => {
                    const preparedLogger = buildAPILoggerDetail(logger)
                    let imgSrc = ""
                    if (preparedLogger.Model.slice(0, 2) === 'CH') {
                        imgSrc = CHF
                        if (preparedLogger.Model.includes('2P')) {
                            imgSrc = CHF2P
                        } else if (preparedLogger.Model.includes('1P')) {
                            imgSrc = CHF1P
                        }
                    }
                    preparedLoggers.push(preparedLogger)
                    markersTemp.push({
                        position: preparedLogger.Latitude && preparedLogger.Longitude ? { lat: preparedLogger.Latitude, lng: preparedLogger.Longitude } : { lat: defaultCenter.lat, lng: defaultCenter.lng },
                        key: preparedLogger.LoggerId,
                        serial: preparedLogger.Serial,
                        tooltip: {
                            model: window.location.hostname.includes('zonelog.net') ? GutermannModelConverter(preparedLogger.Model) : preparedLogger.Model,
                            img: window.location.hostname.includes('zonelog.net') ? ZL : imgSrc,
                            deviceName: preparedLogger.DeviceName
                        },
                        icon: preparedLogger.Latitude && preparedLogger.Longitude ? yellowMarker : redMarker

                    })
                    loggerIdsTemp.push(preparedLogger.LoggerId)
  
                })

            }
            data.loggers = preparedLoggers
            setSite(data)
            
            

            if (data.boundary) {
                const boundaryData: BoundaryData = JSON.parse(data.boundary)
                if (Array.isArray(boundaryData.path)) {
                    setPolygonPath(boundaryData.path)
                    setBoundaryStyle(boundaryData.styling)
                    setHasBoundary(true)
                }
            }

            setMarkers(markersTemp)

            if (loggerIdsTemp.length === 1) {
                sessionStorage.setItem('selectedLoggers', loggerIdsTemp[0].toString())
            } else if (loggerIdsTemp.length > 1) {

                sessionStorage.setItem('selectedLoggers', loggerIdsTemp.map(logger => logger.toString()).join())
            } else {
                sessionStorage.setItem('selectedLoggers', "")
            }

            CallGetAPI(CreateUrl('/api/aquaguard/SitesForCompany?companyId=' + sessionStorage.getItem('companyId') + '&filterGroup=' + sessionStorage.getItem('filterGroupId')), {})
                .then((data: Site[]) => {
                    const unAssignedLoggers = []
                    data.map(site => {
                        if (site.defaultSite) {
                            if (site.loggers.length > 0) {
                                site.loggers.forEach(logger => {
                                    const preparedLogger = buildAPILoggerDetail(logger)
                                    preparedLogger.CompanyName = site.companyName
                                    unAssignedLoggers.push(preparedLogger)
                                })
                            }
                            unAssignedLoggers.sort((a, b) => a.DeploymentDate + b.DeploymentDate)
                        }
                    })
                    setLoggersToBeAssigned(unAssignedLoggers)

                })

        })
        .catch(err => {
            setAuthorized(false)
            console.log(err)
        })
    //Historic Site Logger Info
    CallGetAPI(CreateUrl('/api/aquaguard/HistoryForSite?siteId=' + siteId), {})
        .then(data => {
            let lastDataDateTemp = moment(0)

            data.forEach(item => {
                if (item.endDate && moment(item.endDate).isSameOrAfter(moment(lastDataDateTemp))) {
                    lastDataDateTemp = item.endDate
                }
                if (item.endDate && moment(item.endDate).isAfter(moment(startDate))) {
                    loggerIdsTemp.push(item.loggerId)

                }
            })

            setLastDataDate(lastDataDateTemp)
            setHistoricLoggerData(data.filter(item => item.endDate !== null))
            setLoading(false)
        })
        .catch(err => console.error(err))
    setLoggerIds(loggerIdsTemp)
}


 